import React from 'react';
import { Navigate } from 'react-router';

import { FundingRequestContainer } from './FundingRequestContainer';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';

// Exports
export const Route = () => {
  // Visibility rules: any logged-in user
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/" />;
      }}
    >
      <FundingRequestContainer />
    </RouteErrorBoundary>
  );
};
